/* global DPI_STATS_TMOUT_MS */
import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import Result from "./Result";
import { parseRootUsage } from "./api";
import ActionsContext from "common/ActionsContext";
import View from "common/View";

export const diskUsageRetrieval = () =>
  ifCl.run("show system filesystem").then(parseRootUsage);

const Report = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const doLoad = () => {
    setRequest(diskUsageRetrieval());
  };
  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  return (
    <Request during={request}>
      {(response) => <Result {...response} />}
    </Request>
  );
};

const DiskStatus = () => (
  <View title="Disk Usage">
    <Report />
  </View>
);
export default DiskStatus;
